import createCommonModule from '@/common/store/modules/common';
import { store as storeInstance } from '@/common/root';
import defaultModel from '@/common/models/commonClass.model';
import CommonError from '@/common/utils/errors/CommonError';
import { Store } from 'vuex';
import { defaultPlural } from '@/common/store/modules/common/common.actions';

function composeCommonStore(options: CommonStore<any, unknown>): CommonStore<unknown, unknown> {
  const defaultOptions = {
    name: '',
    plural: defaultPlural,
    singular: '',
    Model: defaultModel,
    resource: '',
    socketUpdates: false
  };

  const opts = { ...defaultOptions, ...options };

  if (!opts.name) {
    throw new CommonError('Module name should not be empty');
  }

  return createCommonModule(opts);
}

export function composeVuexModule(module: CommonStore<unknown, unknown>): CommonStore<unknown, unknown> {
  return module.resource ? composeCommonStore(module) : {
    ...module,
    namespaced: true,
    Model: module.Model, // TODO check if Model not used
  };
}

function storeCreator(props: CommonStore<unknown, unknown>, store: Store<RootState>) {
  const storeName = props.name;
  if (store?.state?.[storeName]) {
    process.env.NODE_ENV === 'development' && console.log(`reusing module: ${storeName}`);

    return 'Reusing module';
  }
  const newModule = composeVuexModule(props);

  store.registerModule(storeName, newModule);
  process.env.NODE_ENV === 'development' && console.log(`created module: ${storeName}`);

  return store;
}

async function storeDeleter(props: CommonStore<unknown, unknown>, store: Store<RootState>) {
  const storeName = props.name;

  if (store?.state?.[storeName]) {
    store.unregisterModule(storeName);
    process.env.NODE_ENV === 'development' && console.log(`deleted module: ${storeName}`);
    return true;
  }

  return false;
}

export function findMutationsByName(storeName: string, mutation: string): Array<string> {
  const regexp = new RegExp(`^${storeName}(?:/.+)?/${mutation}$`);
  // eslint-disable-next-line no-underscore-dangle
  return Object.keys(storeInstance._mutations)
    .filter(mutationName => regexp.test(mutationName));
}

export { storeCreator, storeDeleter };
